module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-layer mask"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      选择审批领导\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("搜索姓名")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.name),
      expression: "model.name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入审批领姓名导"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group btn-box"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.choose
    }
  }, [_vm._v("确认选择")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main_wrap"
  }, [_c('div', {
    staticClass: "table_wrap"
  }, [_c('div', {
    staticClass: "table_layout"
  }, [_c('div', {
    staticClass: "table_scroll "
  }, [_c('el-table', {
    ref: "elTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "max-height": "534",
      "border": "",
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.tableHeaderColor
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "1",
    attrs: {
      "label": "姓名",
      "min-width": "60",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.realname) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "2",
    attrs: {
      "label": "手机号",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.phone) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "3",
    attrs: {
      "label": "小程序id",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.miniOpenId) + "\n                  ")]
      }
    }])
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad1c9f56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/staffManagement/components/leader.vue
// module id = K1tA
// module chunks = 4